import Api from '@/api';

class ListVm {
  sortOrder = 'asc';

  constructor(name, defSortBy, getUrlFunc, dateProps, searchFunc, onClickFunc, columns) {
    this.name = name;

    this.sortBy = defSortBy;
    var descIx = this.sortBy.indexOf(" desc");
    if (descIx > 0) {
      this.sortOrder = 'desc';
      this.sortBy = this.sortBy.substring(0, descIx);
    }

    this.getUrlFunc = getUrlFunc;
    this.dateProps = dateProps;
    this.searchFunc = searchFunc;
    this.onClickFunc = onClickFunc;
    this.columns = columns;
  }

  getFunc = (ctx, cacheMaxAgeSec = 0) => {
    var url = this.getUrlFunc(ctx);
    return Api.Get(url, this.dateProps, cacheMaxAgeSec).then(json => json.value);
  }

  sortFunc = (items) => {
    return items.sort((a, b) => {
      var res = 0;
      if (this.sortBy !== null) {
        var aVal = a[this.sortBy];
        var bVal = b[this.sortBy];

        if (aVal instanceof Date) {
          res = (aVal > bVal) - (aVal < bVal);
        } else if (aVal !== null) {
          res = aVal.localeCompare(bVal);
        } else {
          res = -1;
        }
      }
      return this.sortOrder === 'desc' ? res * -1 : res;
    });
  }
}

export default ListVm;



// WEBPACK FOOTER //
// ./src/components/base/ListVm.js